import React from 'react';

import './SeverityBadge.css';
import { BannerSeverity } from '../../models/banner/BannerObject';

interface SeverityBadgeProps {
  severity: BannerSeverity;
}

function SeverityBadge({ severity }: Readonly<SeverityBadgeProps>): React.ReactElement {
  return (
    <span className={`severity-badge severity-badge-${severity.toLowerCase()}`}>
      {severity}
    </span>
  );
}

export default SeverityBadge;
